module.exports = __webpack_public_path__ + "static/media/inactive-right-shield.8791c273.svg";